import React from "react";
import Dialog from "@material-ui/core/Dialog";

const StudentPausePopup = ({ open, setOpen, children }) => {
  const handleClose = () => {
    setOpen(false);
  };
  const paperStyle = {
    padding: "32px 80px",
    maxWidth: "600px",
    width: "100%",
    borderRadius: "8px",
    boxShadow: "0px 2px 8px 0px #00000029",
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: paperStyle,
        }}
      >
        {children}
      </Dialog>
    </>
  );
};
export default StudentPausePopup;
